import React from 'react';

export function ProgressBar({ currentStep, remainingQuestions, isEstimate }) {
  // Calculate visited questions (currentStep is 0-indexed)
  const visitedCount = currentStep + 1;

  // Calculate total estimated questions
  const totalEstimated = visitedCount + remainingQuestions;

  // Calculate progress percentage
  const progress = totalEstimated > 0
    ? (visitedCount / totalEstimated) * 100
    : 0;

  return (
    <div className="bg-white border-b">
      <div className="max-w-4xl mx-auto px-6 md:py-4 py-2">
        <div className="flex items-center justify-end mb-2">
          <span className="text-sm font-medium text-gray-700">{Math.round(progress)}%</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div
            className="bg-gradient-to-r from-amber-300 to-orange-500 h-2 rounded-full transition-all duration-300"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
}
